import React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';

// project imports
import config from './../config';

//-----------------------|| ROUTING RENDER ||-----------------------//

const Routes = () => {
    return (
        <Switch>
            {/* Redirect to default path */}
            <Redirect exact from="/" to={config.defaultPath} />

            {/* Routes for authentication pages */}
            <Route path={['/login', '/register', '/forgot-password']} component={LoginRoutes} />

            {/* Main routes */}
            <Route path="/" component={MainRoutes} />
        </Switch>
    );
};

export default Routes;
